// extracted by mini-css-extract-plugin
export var active = "_3t-7";
export var container = "_3t-0";
export var evenWidth = "_3t-4";
export var large = "_3t-5";
export var outlet = "_3t-8";
export var slide = "_3t-2";
export var small = "_3t-6";
export var tab = "_3t-3";
export var tabs = "_3t-1";